/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import _ from "lodash";
import React from "react";
import InputField from "../../../../../shared-ui/input-field";

interface NumericValueComponentProps {
  questionType: string;
  inputPlaceHolder: string;
  questionValue: string;
  questionTitle: string;
  answer: any;
  disableAllAnswers: boolean;
  handleInputChange?: (
    questionType: string,
    questionValue: string,
    questionTitle: string,
    answer: any,
    isNeedState: boolean
  ) => void;
}

interface NumericValueComponentState {
  input: string;
}

class NumericValueComponent extends React.Component<
  NumericValueComponentProps,
  NumericValueComponentState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      input: "",
    };
  }

  componentDidMount = () => {
    if (this.props.answer !== undefined) {
      this.setState({
        input: this.props.answer?.value,
      });
    }
  };
  componentDidUpdate = () => {
    if (this.props.answer !== undefined && this.state.input!==this.props.answer?.value) {
      this.setState({
        input: this.props.answer?.value,
      });
    }
  };
  handleInputChange = (e: any) => {
    const { inputPlaceHolder, questionValue, questionTitle, questionType } =
      this.props;

    const { input } = this.state;
    this.setState(
      {
        input: e.target.value,
      },
      () => {
        if (this.props.handleInputChange) {
          this.props.handleInputChange(
            questionType,
            questionValue,
            questionTitle,

            {
              id: questionValue,
              value: e.target.value,
            },
            false
          );
        }
      }
    );
  };

  render() {
    const {
      inputPlaceHolder,
      questionValue,
      questionTitle,
      disableAllAnswers,
    } = this.props;
    const { input } = this.state;

    return (
      <div
        className={
          disableAllAnswers ? "answers-wrapper disabled " : "answers-wrapper"
        }
      >
        <InputField
          type={"text"}
          placeHolder={inputPlaceHolder || ""}
          className={
            "custom-input"
            // isError ? "custom-input error-input" : "custom-input"
          }
          handleInputChange={(e: any) => {
            this.handleInputChange(e);
          }}
          inputValue={input}
          maxLength={3}
        />
      </div>
    );
  }
}

export default NumericValueComponent;
